import {
  Hotel,
  HotelPrice,
  SearchParameters,
  wsAvailability,
} from "../Services/wsSearch";
import { getAmountOfNights } from "./generic";

export type PriceInfo = {
  displayPrice: string;
  currencySymbol: string;
  cutPrice?: string;
  saveAmount?: string;
  directPrice?: number;
  bookingPrice?: number;
  available: boolean;
  isFallback: boolean;
};

export const currencySymbols: Record<string, string> = {
  EUR: "€",
  USD: "$",
};

// export function getDisplayPrice(
//   availability: wsAvailability,
//   deltas: {
//     bookingDeltaPercentage: number;
//     hotelsDeltaPercentage: number;
//   },
//   params: SearchParameters,
// ): PriceInfo | undefined {
//   // No availability case
//   if (!availability.availabilityInfo.available)
//     return {
//       available: false,
//       displayPrice: "-",
//       currencySymbol: "",
//       isFallback: false,
//     };

//   var price = availability.availabilityInfo.value;

//   var bookingDelta = 0;
//   var hotelsDelta = 0;

//   if (availability.availabilityInfo.provider) {
//     if (availability.availabilityInfo.provider === "bookingcom") {
//       bookingDelta = (deltas.bookingDeltaPercentage * price) / 100;
//       price = price - bookingDelta;
//     }
//     if (availability.availabilityInfo.provider === "hotelscom") {
//       hotelsDelta = (deltas.hotelsDeltaPercentage * price) / 100;
//       price = price - hotelsDelta;
//     }
//   }

//   return {
//     displayPrice: Math.round(price).toFixed(0),
//     bookingPrice,
//     saveAmount:
//       bookingPrice - directPrice > 0
//         ? Math.round(bookingPrice - directPrice).toFixed(0)
//         : undefined,
//     currencySymbol: directItem?.currency
//       ? currencySymbols[directItem.currency]
//       : bestOtaItem?.currency
//       ? currencySymbols[bestOtaItem.currency]
//       : "",
//     available: directPrice > 0,
//     isFallback: false,
//   };
// }
